import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const TransportType = ({ roles }) => {

    return (
        <M_Table entityName={'TransportType'} filtersOnTable rolePermissions={roles} />
    )
}